type SourceContextRollupLike = {
  source_context_items?: Array<{ source_context?: string | null; count?: number | null }> | null;
  non_production_total?: number | null;
  production_claim_allowed_total?: number | null;
  real_world_outcome_claimed_total?: number | null;
  risk_reduction_claim_allowed_total?: number | null;
};

export function getSourceContextTotal(
  rollup: SourceContextRollupLike | null | undefined,
  sourceContext: string,
): number {
  const key = String(sourceContext || '').trim().toLowerCase();
  if (!key) return 0;
  return Number(
    Array.isArray(rollup?.source_context_items)
      ? ((rollup?.source_context_items?.find((item) => String(item?.source_context || '').trim().toLowerCase() === key)?.count) || 0)
      : 0,
  );
}

export function buildScopeBoundarySummary(
  rollup: SourceContextRollupLike | null | undefined,
  scopeLabel: string,
): string {
  const nonProductionTotal = Number(rollup?.non_production_total || 0);
  const productionClaimAllowedTotal = Number(rollup?.production_claim_allowed_total || 0);
  if (nonProductionTotal > 0) {
    return `${nonProductionTotal} ${scopeLabel} were measured outside normal operating conditions, so the results should be treated as observed activity rather than verified outcomes.`;
  }
  if (productionClaimAllowedTotal > 0) {
    return `${productionClaimAllowedTotal} ${scopeLabel} currently support standard customer-facing outcome language.`;
  }
  return '';
}

export function buildOutcomeBoundarySummary(
  rollup: SourceContextRollupLike | null | undefined,
  measuredTotal: number,
  scopeLabel: string,
): string {
  const realWorldOutcomeClaimedTotal = Number(rollup?.real_world_outcome_claimed_total || 0);
  const riskReductionClaimAllowedTotal = Number(rollup?.risk_reduction_claim_allowed_total || 0);
  const nonProductionTotal = Number(rollup?.non_production_total || 0);
  if (measuredTotal > 0 && realWorldOutcomeClaimedTotal <= 0 && nonProductionTotal > 0) {
    return `Measured follow-up exists in ${scopeLabel}, but the observed conditions do not yet support a verified improvement conclusion.`;
  }
  if (riskReductionClaimAllowedTotal > 0) {
    return `${riskReductionClaimAllowedTotal} ${scopeLabel} currently support a verified risk-reduction conclusion.`;
  }
  if (measuredTotal > 0 && realWorldOutcomeClaimedTotal <= 0) {
    return `Measured follow-up exists in ${scopeLabel}, but the current scope does not yet support a verified outcome conclusion.`;
  }
  return '';
}
